/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint ignore:start */
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { initiateSocket, getSocket } from "../socket";
import { MyContext } from "../Context/MyProvider";
import { IoCallOutline, IoVideocamOutline, IoChatbubblesSharp, IoClose } from "react-icons/io5";
import { TbDotsCircleHorizontal } from "react-icons/tb";
import { FaArrowLeft } from "react-icons/fa6";
import EmojiPicker from "emoji-picker-react";
import CustomEmojiPicker from "./CustomEmojiPicker";
import { useTranslation } from "react-i18next";
import HidePassword from "../Icon/eye-slash.svg";
import flag from "../Icon/flag-triangle.svg";
import plus from "../Icon/plus.svg";
import Bell from "../Icon/bell-slash.svg";
import BlockIcon from "../Icon/block.gif";
import Setting from "../Icon/settings.svg";
import { ReportComment } from "../utils/reportConstants";
import axios from "axios";
import { HiDotsVertical } from "react-icons/hi";
import WebCallManager from "../User_Call/WebCallManager";
import { useNavigate, useLocation } from "react-router-dom";
import { showTost } from "../showTost";
import LodingLottie from "../Lodinglottie";
import { fetchProfileCompletion, getChatBlockMessage } from "../utils/profileCompletion";

const formatDateHeader = (timestamp) => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  const now = new Date();
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  if (date.toDateString() === now.toDateString()) {
    return "Today";
  } else if (date.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  } else {
    const isSameYear = date.getFullYear() === now.getFullYear();
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      ...(isSameYear ? {} : { year: "numeric" }),
    });
  }
};

const isSameDay = (d1, d2) => {
  if (!d1 || !d2) return false;
  return new Date(d1).toDateString() === new Date(d2).toDateString();
};
const getRegisterUser = () => {
  const localData = localStorage.getItem("Register_User");
  return localData ? JSON.parse(localData) : null;
};

const formatChatTime = (messageTime) => {
  if (!messageTime) return "No time available";
  const msgDate = new Date(messageTime);
  const timeStr = msgDate.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const todayStr = new Date().toDateString();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayStr = yesterday.toDateString();
  const msgDateStr = msgDate.toDateString();

  if (msgDateStr === todayStr) return `Today ${timeStr}`;
  if (msgDateStr === yesterdayStr) return `Yesterday ${timeStr}`;
  return `${msgDate.toLocaleString("en-US", { weekday: "long" })} ${timeStr}`;
};

const UserChat = () => {
  const { t } = useTranslation();

  const {
    chatId,
    imageBaseURL,
    chatUserName,
    setChatUserName,
    basUrl,
    setChatId,
    isVoiceCalling,
    setIsVoiceCalling,
    isVideoCalling,
    setIsVideoCalling,
    socketDebugToast,
    callMode,
  } = useContext(MyContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!hasInitializedTargetRef.current) {
      const targetId = location.state?.ProfileId || location.state?.otherId || sessionStorage.getItem("DetailsId") || chatId;
      if (targetId) {
        setReceiverId(targetId);
        if (setChatId) setChatId(targetId);
        if (location.state?.name && setChatUserName) {
          setChatUserName(location.state.name);
        }
      }
    }
  }, [location.state, chatId, setChatId, setChatUserName]);

  const [message, setMessage] = useState("");
  const [allChat, setAllChat] = useState([]);
  const [userName, setUserName] = useState();
  const [receiverId, setReceiverId] = useState();
  const [senderId, setSenderId] = useState();
  const [profilePic, setProfilePic] = useState();
  const [audio_video, setAudio_Video] = useState();
  const [lastMsg, setLastMsg] = useState([]);
  const [loading, setLoading] = useState(true);

  const [input, setInput] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [sortData, setSortData] = useState([]);

  const [options, setOption] = useState(false);
  const [report, setReport] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [isUserTyping, setIsUserTyping] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const typingTimeoutRef = useRef(null);
  const [chatUserBlock, setChatUserBlock] = useState([]);
  const [warningData, setWarningData] = useState(null);
  const [blockedData, setBlockedData] = useState(null);
  const [isBlocked, setIsBlocked] = useState(false);
  const [dot, setDot] = useState("");
  const [comment, setComment] = useState();
  const chatCompletionCheckedRef = useRef(false);

  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [callChannelName, setCallChannelName] = useState();
  const [deviceCheck, setDeviceCheck] = useState();
  const audioCallEnabled = callMode === "audio_only" || callMode === "audio_video";
  const videoCallEnabled = callMode === "video_only" || callMode === "audio_video";
  const hasCallPlan = String(audio_video) === "1";

  const requireCallPlan = () => {
    if (hasCallPlan) return true;
    setIsVoiceCalling(false);
    setIsVideoCalling(false);
    navigate("/upgrade", { state: { returnTo: "/chat" } });
    return false;
  };

  useEffect(() => {
    const verifyChatCompletion = async () => {
      if (chatCompletionCheckedRef.current) return;
      chatCompletionCheckedRef.current = true;
      const user = getRegisterUser();
      const completion = await fetchProfileCompletion(basUrl, user?.id);
      const chatBlockMessage = getChatBlockMessage(completion);
      if (chatBlockMessage) {
        showTost({ title: chatBlockMessage });
        setChatId("");
        navigate("/profile", {
          state: {
            profileCompletionRequired: true,
            missingTasks: completion?.missing_tasks || [],
          },
        });
      }
    };
    verifyChatCompletion();
  }, [basUrl, navigate, setChatId]);

  const chatBoxBodyRef = useRef(null);
  const Open = useRef();

  const fetchUserData = useCallback(async (lat = latitude, long = longitude) => {
    const userData = getRegisterUser();
    if (!userData) return;
    try {
      const response = await axios.post(`${basUrl}home_data`, {
        uid: userData.id,
        lats: lat,
        longs: long,
      });
      if (response.data.Result === "true") {
        setAudio_Video(response.data.audio_video);
      }
    } catch (error) {
      console.error("Error :", error);
    }
  }, [basUrl, latitude, longitude]);

  useEffect(() => {
    if (chatBoxBodyRef.current) {
      chatBoxBodyRef.current.scrollTop = chatBoxBodyRef.current.scrollHeight;
    }
  }, [allChat, isUserTyping]);

  const fetchMyChats = useCallback(async () => {
    const userData = getRegisterUser();
    if (!userData) return;
    try {
      setLoading(true);
      const response = await axios.post(`${basUrl}my_chats`);
      if (response.data.Result === "true") {
        const chats = (response.data.chatlist || []).map(chat => ({
          ...chat,
          otherId: chat.uid,
          sortchat: chat.timestamp ? new Date(chat.timestamp) : new Date(0),
          timestamp: chat.timestamp ? formatChatTime(new Date(chat.timestamp)) : ""
        }));
        setLastMsg(chats);
      }
    } catch (error) {
      console.error("Error fetching chats:", error);
    } finally {
      setLoading(false);
    }
  }, [basUrl]);

  const fetchChatHistory = useCallback(async (otherId) => {
    if (!otherId) return;
    try {
      const response = await axios.post(`${basUrl}chat_history`, { other_id: otherId });
      if (response.data.Result === "true") {
        const formatted = (response.data.chatlist || []).map(msg => ({
          ...msg,
          formattedTime: formatChatTime(new Date(msg.timestamp))
        }));
        setAllChat(formatted);
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  }, [basUrl]);

  useEffect(() => {
    const Data = getRegisterUser();
    if (Data) {
      setSenderId(Data.id);

      fetchMyChats();

      // Initiate/connect socket
      const socket = initiateSocket(Data.token, socketDebugToast);

      const handleIncomingMessage = (msg) => {
        // If message is in the active chat conversation
        if (
          (String(msg.senderid) === String(Data.id) && String(msg.reciverId) === String(receiverId)) ||
          (String(msg.senderid) === String(receiverId) && String(msg.reciverId) === String(Data.id))
        ) {
          setAllChat((prev) => {
            if (prev.some((m) => m.id === msg.id)) return prev;
            return [
              ...prev,
              {
                ...msg,
                formattedTime: formatChatTime(new Date(msg.timestamp))
              }
            ];
          });
          // Mark as read
          socket.emit("read_receipt", { senderId: receiverId });
        }

        // Update last message in the chat list
        setLastMsg((prevLastMsg) => {
          const otherUserId = String(msg.senderid) === String(Data.id) ? msg.reciverId : msg.senderid;
          const exists = prevLastMsg.some(c => String(c.otherId) === String(otherUserId));

          let updated;
          if (exists) {
            updated = prevLastMsg.map((chat) => {
              if (String(chat.otherId) === String(otherUserId)) {
                return {
                  ...chat,
                  lastMessage: msg.message,
                  timestamp: formatChatTime(new Date(msg.timestamp)),
                  sortchat: new Date(msg.timestamp)
                };
              }
              return chat;
            });
          } else {
            fetchMyChats();
            return prevLastMsg;
          }

          return updated.sort((a, b) => b.sortchat - a.sortchat);
        });
      };

      socket.on("message", handleIncomingMessage);

      socket.on("typing", (data) => {
        console.log("[REACT SOCKET] typing event received:", data, "current receiverId:", receiverId);
        if (String(data.senderId) === String(receiverId)) {
          setIsUserTyping(data.isTyping);
        }
      });

      socket.on("read_receipt", (data) => {
        if (String(data.readerId) === String(receiverId)) {
          setAllChat((prev) =>
            prev.map((msg) =>
              String(msg.senderid) === String(Data.id) ? { ...msg, status: "read" } : msg
            )
          );
        }
      });

      socket.on("chat_warning", (data) => {
        setWarningData(data);
      });

      socket.on("chat_blocked", (data) => {
        setIsBlocked(true);
        setBlockedData(data);
      });

      socket.on("chat_unblocked", () => {
        setIsBlocked(false);
        setBlockedData(null);
        setWarningData(null);
      });

      return () => {
        socket.off("message", handleIncomingMessage);
        socket.off("read_receipt");
        socket.off("typing");
        socket.off("chat_warning");
        socket.off("chat_blocked");
        socket.off("chat_unblocked");
      };
    }
  }, [fetchMyChats, receiverId, socketDebugToast]);

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
    
    // Emit typing indicator
    const socket = getSocket();
    if (socket && receiverId) {
      if (!isTyping) {
        setIsTyping(true);
        socket.emit("typing", { receiverId: receiverId, isTyping: true });
      }
      
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
      
      typingTimeoutRef.current = setTimeout(() => {
        setIsTyping(false);
        socket.emit("typing", { receiverId: receiverId, isTyping: false });
      }, 2000);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") handleSendMessage();
  };

  const handleSendMessage = async () => {
    if (!senderId || !receiverId) {
      showTost({ title: "Please Select User" });
      return;
    }
    
    const trimmedMessage = message.trim();
    if (!trimmedMessage) {
      showTost({ title: "Please Write Meassage" });
      return;
    }

    const socket = getSocket();
    if (socket) {
      socket.emit("send_message", {
        receiverId: receiverId,
        message: trimmedMessage,
        type: "text"
      }, (response) => {
        if (response && response.status === "success") {
          setMessage("");
        } else if (response && response.status === "warning") {
          setMessage("");
          setWarningData(response);
        } else if (response && response.status === "blocked") {
          setIsBlocked(true);
          setBlockedData(response);
        } else {
          showTost({ title: response?.error || "Failed to send message" });
        }
      });
    } else {
      showTost({ title: "Not connected to chat server" });
    }
  };

  const initialTargetCheckedRef = useRef(false);
  const hasInitializedTargetRef = useRef(false);

  const UserChangHandler = (user) => {
    hasInitializedTargetRef.current = true;
    const targetId = user.otherId || user.uid;
    setReceiverId(targetId);
    setUserName(user.name);
    setProfilePic(user.pro_pic);
    if (setChatId) setChatId(targetId);
    if (setChatUserName) setChatUserName(user.name);
    sessionStorage.setItem("DetailsId", targetId);
    if (window.innerWidth < 1200) {
      Open.current?.classList.add("open");
    }
  };

  const ChatOffHandler = () => {
    Open.current?.classList.remove("open");
  };

  const handleButtonClick = () => {
    if (receiverId) {
      setShowPicker(!showPicker);
    } else {
      showTost({ title: "Please Select User" });
    }
  };

  useEffect(() => {
    setIsUserTyping(false);
    setIsTyping(false);
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
  }, [receiverId]);
  useEffect(() => {
    if (receiverId) {
      fetchChatHistory(receiverId);
      const socket = getSocket();
      if (socket) {
        socket.emit("read_receipt", { senderId: receiverId });
      }
    }
  }, [fetchChatHistory, receiverId]);

  const memoizedSortedData = useMemo(() => {
    return lastMsg;
  }, [lastMsg]);

  useEffect(() => {
    setSearchData(memoizedSortedData);
    setSortData(memoizedSortedData);

    if (!hasInitializedTargetRef.current) {
      hasInitializedTargetRef.current = true;
      const navTargetId = location.state?.ProfileId || location.state?.otherId;
      const targetId = navTargetId || sessionStorage.getItem("DetailsId") || chatId;

      if (targetId) {
        const activeUser = lastMsg.find(c => String(c.otherId || c.uid) === String(targetId));
        if (activeUser) {
          setReceiverId(activeUser.otherId || activeUser.uid);
          setUserName(activeUser.name);
          setProfilePic(activeUser.pro_pic);
          if (setChatId) setChatId(activeUser.otherId || activeUser.uid);
          if (setChatUserName) setChatUserName(activeUser.name);
        } else {
          setReceiverId(targetId);
          if (location.state?.name) setUserName(location.state.name);
          if (location.state?.pro_pic !== undefined) setProfilePic(location.state.pro_pic);
          if (setChatId) setChatId(targetId);
          if (setChatUserName && location.state?.name) setChatUserName(location.state.name);
        }
        return;
      }
    }

    if (lastMsg.length > 0 && !receiverId) {
      const defaultUser = lastMsg[0];
      setReceiverId(defaultUser.otherId || defaultUser.uid);
      setUserName(defaultUser.name);
      setProfilePic(defaultUser.pro_pic);
      if (setChatId) setChatId(defaultUser.otherId || defaultUser.uid);
      if (setChatUserName) setChatUserName(defaultUser.name);
    }
  }, [memoizedSortedData, lastMsg, location.state, chatId, setChatId, setChatUserName, receiverId]);


  const handleEmojiSelect = (e) => {
    setMessage((prev) => prev + e.emoji);
    setShowPicker(false);
  };

  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }, []);

  const checkDevices = async (needVideo) => {
    try {
      if (!navigator.mediaDevices?.getUserMedia) {
        setDeviceCheck("Your browser does not support audio/video calling.");
        return false;
      }
      const devices = await navigator.mediaDevices.enumerateDevices();
      const hasMic = devices.some((d) => d.kind === "audioinput");
      const hasCam = devices.some((d) => d.kind === "videoinput");
      if (!hasMic || (needVideo && !hasCam)) {
        setDeviceCheck(
          needVideo
            ? "Required for video calls. Ensure your camera is enabled and functioning for clear video communication."
            : "Required for voice and video calls. Make sure your audio device (headset, speakers, or microphone) is connected and working.",
        );
        return false;
      }
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: needVideo,
      });
      stream.getTracks().forEach((track) => track.stop());
      return true;
    } catch (e) {
      console.error("Error checking devices:", e);
      setDeviceCheck(
        needVideo
          ? "Camera or microphone permission is blocked. Allow camera and microphone access in the browser, then try again."
          : "Microphone permission is blocked. Allow microphone access in the browser, then try again.",
      );
      return false;
    }
  };

  const AudioCallHandler = async () => {
    if (!requireCallPlan()) return;
    if (!audioCallEnabled) return showTost({ title: "Audio calls are disabled right now." });
    if (!(await checkDevices(false))) return;
    if (!receiverId) return showTost({ title: "Please Select User" });

    const channelName = [senderId, receiverId].sort().join("_");
    setCallChannelName(channelName);
    setIsVoiceCalling(true);
    CallStatusHandler(channelName, "audio");
  };

  const VideoCallHandler = async () => {
    if (!requireCallPlan()) return;
    if (!videoCallEnabled) return showTost({ title: "Video calls are disabled right now." });
    if (!(await checkDevices(true))) return;
    if (!receiverId) return showTost({ title: "Please Select User" });

    const channelName = [senderId, receiverId].sort().join("_");
    setCallChannelName(channelName);
    setIsVideoCalling(true);
    CallStatusHandler(channelName);
  };

  const CallStatusHandler = async (channelName, type) => {
    const socket = getSocket();
    if (socket) {
      socket.emit("call_user", {
        receiverId: receiverId,
        type: type === "audio" ? "audio" : "video",
        channel: channelName
      });
    }
  };

  const ModalShow = () => {
    if (chatId || receiverId) {
      setOption(!options);
    } else {
      showTost({ title: "Please Select User" });
    }
  };

  const ReportToggle = (e) => {
    setReport(e === "ReportSection" ? false : true);
  };

  const SendReportHamdler = () => {
    if (dot !== "") {
      const userData = getRegisterUser();
      if (!userData) return;

      axios
        .post(`${basUrl}report`, {
          uid: userData.id,
          reporter_id: chatId,
          comment: comment,
        })
        .then((res) => {
          if (res.data.Result === "true") {
            showTost({ title: "Report Send successfully!!" });
            setReport(false);
            setChatId("");
          }
        });
    } else {
      showTost({ title: "Something Went Wrong" });
    }
  };

  const toggleBottomSheet = (e) => {
    setIsVisible(e !== "BlockSection");
  };

  const BlockHandler = () => {
    const userData = getRegisterUser();
    if (!userData) return;
    const blockId = chatId || receiverId;
    axios
      .post(`${basUrl}profile_block`, {
        uid: userData.id,
        profile_id: blockId,
      })
      .then((res) => {
        if (res.data.Result === "true") {
          BlockListUserHandler(latitude, longitude, 1);
          showTost({ title: "Profile Block Successfully" });
          if (chatId) navigate("/");
          setIsVisible(false);
          setChatId("");
        } else {
          showTost({ title: "Profile Block Already" });
          setIsVisible(false);
          setChatId("");
        }
      });
  };

  const BlockListUserHandler = useCallback((lat, long, id) => {
    const userData = getRegisterUser();
    if (!userData) return;
    axios
      .post(`${basUrl}blocklist`, {
        uid: userData.id,
        lats: lat,
        longs: long,
      })
      .then((res) => {
        if (res.data.Result === "true") {
          const blockIds = res.data.blocklist.map((item) => item.profile_id);
          setChatUserBlock(blockIds);
          if (id) {
            setUserName("");
            setProfilePic("");
            setReceiverId("");
            setAllChat([]);
          }
        }
      });
  }, [basUrl]);

  useEffect(() => {
    if (latitude && longitude) return;
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = String(position.coords.latitude);
        const long = String(position.coords.longitude);
        setLatitude(lat);
        setLongitude(long);
        BlockListUserHandler(lat, long);
        fetchUserData(lat, long);
      }
    );
  }, [BlockListUserHandler, fetchUserData, latitude, longitude]);

  useEffect(() => {
    if (!input) {
      setSearchData(sortData);
    } else {
      setSearchData(
        sortData.filter((item) =>
          item.name?.toLowerCase().includes(input.toLowerCase()),
        ),
      );
    }
  }, [input, sortData]);

  const GetUserImgHamdle = useCallback(async (lat, long) => {
    const userData = getRegisterUser();
    if (!userData) return;
    try {
      const res = await axios.post(`${basUrl}profile_info`, {
        uid: userData.id,
        profile_id: chatId,
        lats: lat,
        longs: long,
      });
      const pic = res.data.profileinfo?.profile_images?.[0];
      setProfilePic(pic);
    } catch (error) {
      console.error("Error fetching profile image", error);
    }
  }, [basUrl, chatId]);

  useEffect(() => {
    if (!chatId) return;
    navigator.geolocation.getCurrentPosition((position) => {
      GetUserImgHamdle(
        String(position.coords.latitude),
        String(position.coords.longitude),
      );
    });
  }, [GetUserImgHamdle, chatId]);

  const ChatCloseHandle = () => {
    setChatId("");
    sessionStorage.setItem("ChatId", "");
  };

  return (
    <>
      <div
        onClick={() => {
          if (showPicker) {
            handleButtonClick();
          }
          options && ModalShow();
        }}
        className="main-wrapper-3 bg-[#e5e5e5] flex"
      >
        <div className="content-body">
          <div className="container-fluid my-2 px-sm-4 px-3">
            <div
              ref={Open}
              className="main-chart-wrapper abcd d-lg-flex max-_1200_:-mt-[125px] max-_1200_:h-[100vh]"
            >
              <div
                className="chat-sidebar-info card card-rounded p-sm-4 p-3 max-_1200_:mt-[125px] max-_1200_:h-[80%] flex flex-col justify-between"
                style={{ height: "calc(100vh - 160px)", minHeight: "620px" }}
              >
                <div className="sidebar-search flex items-center mb-3">
                  <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    className="searchbar mx-lg-0 form-control bg-white focus-within:outline-[rgba(152,14,255,255)]"
                    placeholder={t("Search")}
                  />
                  <div className="-ms-[30px]">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.2934 10.7265C12.9169 10.3499 11.7297 9.47339 10.5511 8.79473C10.5384 8.81388 10.5256 8.83302 10.5128 8.8543C11.8425 6.71194 11.5808 3.85902 9.71926 1.99749C7.54925 -0.170388 4.03256 -0.170388 1.86255 1.99749C-0.30746 4.16963 -0.305333 7.68419 1.86255 9.85422C3.70706 11.6966 6.52169 11.9753 8.65766 10.6861C9.27249 11.754 10.1682 13.0071 10.5915 13.4305C11.3361 14.1751 12.5488 14.173 13.2934 13.4284C14.038 12.6816 14.038 11.4732 13.2934 10.7265ZM8.25559 8.39051C6.89401 9.74996 4.68996 9.74996 3.32839 8.38838C1.96894 7.02894 1.96682 4.82489 3.32839 3.46331C4.68784 2.10387 6.89401 2.10387 8.25346 3.46331C9.61504 4.82489 9.61503 7.03106 8.25559 8.39051Z"
                        fill="#999999"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div className="chat-message-list flex-1 overflow-hidden">
                  <ul className="my-2 scroll-msg flex-1 overflow-y-auto" id="msgList" style={{ height: "calc(100vh - 250px)", minHeight: "520px" }}>
                    {loading ? (
                      <div className="flex justify-center items-center h-full">
                        <LodingLottie ClassCss="w-[20%] max-_430_:w-[100%] max-_770_:w-[50%] max-_1030_:w-[40%] max-_1145_:w-[30%] max-_1200_:w-[30%] max-_1300_:w-[30%]" />
                      </div>
                    ) : searchData?.length > 0 ? (
                      searchData?.map((user, index) => {
                        if (!chatUserBlock.includes(user.otherId)) {
                          const isSelected = String(user.otherId || user.uid) === String(receiverId);
                          return (
                            <li
                              key={index}
                              onClick={() => UserChangHandler(user)}
                              className={`cursor-pointer p-2 rounded-xl transition-all ${isSelected ? 'bg-purple-50 border-l-4 border-purple-600 font-bold' : 'hover:bg-gray-50'}`}
                            >
                              <div className="unread-msg-user">
                                <div className="d-flex align-items-center gap-[10px]">
                                  {user.pro_pic === "null" ||
                                  user.pro_pic === null ? (
                                    <div className="bg-gray-300 rounded-full w-[75px] h-[3.4rem] flex justify-center items-center text-[22px] font-bold max-_430_:w-[70px] max-_770_:w-[60px] max-_1030_:w-[65px] max-_1145_:w-[60px]">
                                      {user?.name?.charAt(0).toUpperCase()}
                                    </div>
                                  ) : (
                                    <img
                                      src={imageBaseURL + user.pro_pic}
                                      className="rounded-circle avatar-md object-fit-cover"
                                      alt="userimage"
                                    />
                                  )}

                                  <div className="short-msg flex items-center justify-between overflow-hidden mx-1 text-start flex-1 min-w-0">
                                    <div className="flex-1 min-w-0 pr-2">
                                      <h6 className="text-truncate mb-0 lh-1 fw-bold text-gray-900 text-sm">
                                        {user.name}
                                      </h6>
                                      <h6 className="text-gray-500 text-xs m-0 pt-[3px] overflow-ellipsis overflow-hidden whitespace-nowrap">
                                        {user.lastMessage}
                                      </h6>
                                    </div>
                                    <span className="text-[11px] text-gray-400 font-medium whitespace-nowrap shrink-0 self-start pt-0.5">
                                      {user.timestamp}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </li>
                          );
                        }
                        return null;
                      })
                    ) : (
                      <div className="text-center mt-5 text-gray-500">
                        {t("No Chats Found")}
                      </div>
                    )}
                  </ul>
                </div>
              </div>

              <div className="main-chat-area w-100 max-_1200_:mt-[125px]" style={{ height: "calc(100vh - 160px)", minHeight: "620px" }}>
                {receiverId ? (
                  <div
                    onClick={() => options && setOption(false)}
                    style={{ width: "100%", display: "flex", flexDirection: "column", height: "calc(100vh - 160px)", minHeight: "620px" }}
                    className="chat-box bg-white p-3.5 border border-gray-100 shadow-sm rounded-2xl w-full flex flex-col justify-between overflow-hidden"
                  >
                    <div className="px-4 py-2.5 flex items-center justify-between border-b border-gray-100 bg-white rounded-t-2xl shrink-0">
                      <div className="flex items-center gap-3 w-full">
                        <button onClick={ChatCloseHandle} className="text-gray-500 hover:text-purple-600 transition-colors">
                          <FaArrowLeft className="text-[20px]" />
                        </button>
                        {profilePic ? (
                          <img
                            src={`${imageBaseURL}${profilePic}`}
                            alt="User Avatar"
                            className="w-10 h-10 rounded-full object-cover border-2 border-purple-200 shadow-sm"
                          />
                        ) : (
                          <div className="bg-purple-100 text-purple-600 rounded-full w-10 h-10 flex justify-center items-center text-base font-bold border-2 border-purple-200">
                            {userName?.charAt(0).toUpperCase()}
                          </div>
                        )}
                        <h6 className="m-0 overflow-ellipsis overflow-hidden whitespace-nowrap w-[60%] font-bold text-gray-800 text-base">
                          {userName}
                        </h6>
                      </div>
                      <div className="flex items-center gap-3 relative text-gray-500">
                        <button onClick={AudioCallHandler} className="p-2 hover:text-purple-600 hover:bg-purple-50 rounded-full transition-colors">
                          <IoCallOutline className="text-[22px]" />
                        </button>
                        <button onClick={VideoCallHandler} className="p-2 hover:text-purple-600 hover:bg-purple-50 rounded-full transition-colors">
                          <IoVideocamOutline className="text-[22px]" />
                        </button>
                        <button onClick={ModalShow} className="p-2 hover:text-purple-600 hover:bg-purple-50 rounded-full transition-colors">
                          <TbDotsCircleHorizontal className="text-[22px]" />
                        </button>
                        {options && (
                          <div className="bg-white shadow-xl border border-gray-100 m-0 px-2 py-1 top-[42px] right-0 rounded-xl absolute z-[888] w-[140px]">
                            <button
                              onClick={toggleBottomSheet}
                              className="py-2 px-3 flex items-center gap-2 text-xs font-semibold text-gray-700 hover:text-purple-600 hover:bg-purple-50 rounded-lg w-full transition-colors"
                            >
                              <img src={HidePassword} style={{ height: "16px" }} alt="" />{" "}
                              {t("Block")}
                            </button>
                            <div className="border-t border-gray-100 my-1"></div>
                            <button
                              onClick={ReportToggle}
                              className="py-2 px-3 flex items-center gap-2 text-xs font-semibold text-red-600 hover:bg-red-50 rounded-lg w-full transition-colors"
                            >
                              <img src={flag} alt="" style={{ height: "16px" }} />{" "}
                              {t("Report")}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div
                      className="chat-body scroll-Chat p-2.5 rounded-xl my-2 border border-gray-100/80 flex-1 min-h-0 overflow-y-auto"
                      id="msgInOut"
                      ref={chatBoxBodyRef}
                      style={{ flex: 1, minHeight: 0, overflowY: "auto", background: "#f8fafc" }}
                    >
                      <style>{`
                        @keyframes bounce {
                          from { transform: translateY(0); }
                          to { transform: translateY(-4px); }
                        }
                        .dot-bounce {
                          display: inline-block;
                        }
                        .scroll-Chat.chat-body {
                          background: #f8fafc !important;
                        }
                        .scroll-Chat .msg-in,
                        .scroll-Chat .msg-out {
                          padding: 0.35rem 0.5rem 0 !important;
                        }
                        .scroll-Chat ul {
                          padding-left: 0 !important;
                          padding-right: 0 !important;
                          margin-bottom: 0 !important;
                        }
                      `}</style>
                      <ul>
                        {allChat.length > 0 &&
                          allChat.map((el, index) => {
                            if (!chatUserBlock.includes(el.uid)) {
                              const isMe = String(el.senderid) === String(senderId);
                              const showDateHeader =
                                index === 0 ||
                                !isSameDay(el.timestamp, allChat[index - 1].timestamp);

                              return (
                                <React.Fragment key={index}>
                                  {showDateHeader && (
                                    <li className="text-center my-3 select-none" style={{ listStyle: "none" }}>
                                      <span
                                        className="px-3 py-1 text-muted rounded-pill shadow-sm"
                                        style={{ fontSize: "12px", fontWeight: "600", display: "inline-block", background: "#e2e8f0", color: "#475569" }}
                                      >
                                        {formatDateHeader(el.timestamp)}
                                      </span>
                                    </li>
                                  )}
                                  <li className={`${isMe ? "msg-out" : "msg-in"}`}>
                                    <div className="msg-list-inner">
                                      <h1 className="msg-text text-center m-0">
                                        {el.message}
                                      </h1>{" "}
                                      <br />
                                      <span className="msg-date inline-block">
                                        {el.formattedTime}
                                        {isMe && (
                                          <span className="ml-1 inline-block align-middle">
                                            {el.status === "read" ? (
                                              <svg width="15" height="15" viewBox="0 0 16 16" fill="none" className="inline-block align-middle">
                                                <path d="M1.5 8.5L4.5 11.5L11 5" stroke="#53bdeb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M5.5 8.5L8.5 11.5L15 5" stroke="#53bdeb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                              </svg>
                                            ) : (
                                              <svg width="15" height="15" viewBox="0 0 16 16" fill="none" className="inline-block align-middle">
                                                <path d="M1.5 8.5L4.5 11.5L11 5" stroke="#8696a0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                <path d="M5.5 8.5L8.5 11.5L15 5" stroke="#8696a0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                              </svg>
                                            )}
                                          </span>
                                        )}
                                      </span>
                                    </div>
                                  </li>
                                </React.Fragment>
                              );
                            }
                            return null;
                          })}
                        {isUserTyping && (
                          <li className="msg-in select-none">
                            <div className="msg-list-inner" style={{ padding: '8px 16px', background: '#f1f5f9', borderRadius: '16px', width: 'fit-content' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px', lineHeight: '1' }}>
                                <span className="text-secondary mr-1" style={{ fontSize: '13px', fontWeight: '500', display: 'inline-block', verticalAlign: 'middle', lineHeight: '1' }}>typing</span>
                                <span className="dot-bounce" style={{ width: '5px', height: '5px', backgroundColor: '#6c757d', borderRadius: '50%', display: 'inline-block', verticalAlign: 'middle', animation: 'bounce 0.6s infinite alternate', animationDelay: '0ms' }}></span>
                                <span className="dot-bounce" style={{ width: '5px', height: '5px', backgroundColor: '#6c757d', borderRadius: '50%', display: 'inline-block', verticalAlign: 'middle', animation: 'bounce 0.6s infinite alternate', animationDelay: '150ms' }}></span>
                                <span className="dot-bounce" style={{ width: '5px', height: '5px', backgroundColor: '#6c757d', borderRadius: '50%', display: 'inline-block', verticalAlign: 'middle', animation: 'bounce 0.6s infinite alternate', animationDelay: '300ms' }}></span>
                              </div>
                            </div>
                          </li>
                        )}
                      </ul>
                    </div>

                    <div className="chat-footer relative mt-auto">
                      {isBlocked && (
                        <div className="alert alert-danger mb-2 text-center py-2" style={{ borderRadius: '8px', fontSize: '13px' }}>
                          <i className="fa fa-lock mr-2"></i> Your chat privileges are suspended due to restricted word violations.
                        </div>
                      )}
                      
                      {!isBlocked && (
                        <div className="flex items-center gap-1 px-3 py-1 bg-white/90 backdrop-blur-md border border-purple-100 rounded-full shadow-sm mb-1.5 w-fit">
                          <span className="text-[10px] font-extrabold text-purple-400 uppercase tracking-wider mr-1">Quick:</span>
                          {["❤️", "😂", "😍", "🔥", "👍", "🥳", "🎉", "💯", "✨"].map((emoji) => (
                            <button
                              key={emoji}
                              type="button"
                              onClick={() => handleEmojiSelect({ emoji })}
                              className="hover:scale-130 transition-transform duration-200 cursor-pointer text-base p-1 hover:bg-purple-100/60 rounded-full active:scale-95 border-0 bg-transparent"
                              title={emoji}
                            >
                              {emoji}
                            </button>
                          ))}
                        </div>
                      )}

                      <div className="flex items-center px-2 py-1.5 border border-gray-200 rounded-2xl bg-white shadow-sm w-full gap-2 relative">
                        <button
                          onClick={handleButtonClick}
                          aria-label="button"
                          type="button"
                          className="btn emoji px-2.5 py-0 border-right relative"
                          disabled={isBlocked}
                        >
                          <svg
                            width="22"
                            height="23"
                            viewBox="0 0 22 23"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.7929 0.901855C8.69446 0.901855 6.64314 1.52412 4.89835 2.68995C3.15356 3.85578 1.79366 5.51283 0.99062 7.45153C0.187581 9.39024 -0.0225313 11.5235 0.386855 13.5817C0.796241 15.6398 1.80674 17.5303 3.29056 19.0141C4.77439 20.4979 6.66489 21.5084 8.72302 21.9178C10.7811 22.3272 12.9144 22.1171 14.8531 21.3141C16.7919 20.511 18.4489 19.1511 19.6147 17.4063C20.7806 15.6615 21.4028 13.6102 21.4028 11.5118C21.3996 8.69883 20.2808 6.002 18.2917 4.01294C16.3027 2.02389 13.6059 0.905038 10.7929 0.901855ZM13.6222 7.26781C13.902 7.26781 14.1755 7.35078 14.4082 7.50622C14.6408 7.66166 14.8221 7.8826 14.9292 8.1411C15.0363 8.39959 15.0643 8.68403 15.0097 8.95845C14.9551 9.23287 14.8204 9.48493 14.6225 9.68278C14.4247 9.88062 14.1726 10.0154 13.8982 10.0699C13.6238 10.1245 13.3393 10.0965 13.0809 9.98943C12.8224 9.88236 12.6014 9.70104 12.446 9.4684C12.2905 9.23576 12.2076 8.96226 12.2076 8.68246C12.2076 8.30727 12.3566 7.94745 12.6219 7.68215C12.8872 7.41685 13.247 7.26781 13.6222 7.26781ZM7.9636 7.26781C8.24339 7.26781 8.5169 7.35078 8.74954 7.50622C8.98218 7.66166 9.1635 7.8826 9.27057 8.1411C9.37764 8.39959 9.40565 8.68403 9.35107 8.95845C9.29648 9.23287 9.16175 9.48493 8.96391 9.68278C8.76607 9.88062 8.514 10.0154 8.23958 10.0699C7.96516 10.1245 7.68073 10.0965 7.42223 9.98943C7.16374 9.88236 6.9428 9.70104 6.78735 9.4684C6.63191 9.23576 6.54894 8.96226 6.54894 8.68246C6.54894 8.30727 6.69798 7.94745 6.96328 7.68215C7.22858 7.41685 7.58841 7.26781 7.9636 7.26781ZM16.3101 14.6948C15.7514 15.6628 14.9478 16.4666 13.9799 17.0255C13.012 17.5844 11.9141 17.8787 10.7964 17.8787C9.6788 17.8787 8.58085 17.5844 7.613 17.0255C6.64514 16.4666 5.84148 15.6628 5.28282 14.6948C5.23301 14.6142 5.19987 14.5245 5.18536 14.431C5.17086 14.3374 5.17529 14.2419 5.19839 14.15C5.22149 14.0582 5.26279 13.972 5.31984 13.8964C5.37689 13.8208 5.44853 13.7575 5.53052 13.7101C5.6125 13.6628 5.70316 13.6324 5.79713 13.6207C5.89109 13.609 5.98643 13.6163 6.07752 13.6422C6.1686 13.668 6.25357 13.7119 6.32738 13.7712C6.40119 13.8305 6.46234 13.904 6.50721 13.9874C6.9416 14.7407 7.56672 15.3663 8.31968 15.8013C9.07264 16.2363 9.92687 16.4653 10.7964 16.4653C11.666 16.4653 12.5203 16.2363 13.2732 15.8013C14.0262 15.3663 14.6513 14.7407 15.0857 13.9874C15.1306 13.904 15.1917 13.8305 15.2655 13.7712C15.3393 13.7119 15.4243 13.668 15.5154 13.6422C15.6065 13.6163 15.7018 13.609 15.7958 13.6207C15.8897 13.6324 15.9804 13.6628 16.0624 13.7101C16.1444 13.7575 16.216 13.8208 16.273 13.8964C16.3301 13.972 16.3714 14.0582 16.3945 14.15C16.4176 14.2419 16.422 14.3374 16.4075 14.431C16.393 14.5245 16.3599 14.6142 16.3101 14.6948Z"
                              fill="#999999"
                            />
                          </svg>
                        </button>

                        {showPicker && (
                          <div className="absolute left-0 bottom-[60px] z-[9999]">
                            <CustomEmojiPicker
                              onSelect={(emoji) => handleEmojiSelect({ emoji })}
                              onClose={() => setShowPicker(false)}
                            />
                          </div>
                        )}

                        <input
                          value={message}
                          onChange={handleMessageChange}
                          onKeyDown={handleKeyPress}
                          className="form-control focus-within:outline-[rgba(152,14,255,255)]"
                          placeholder={t("Write message here...")}
                          type="text"
                          disabled={isBlocked}
                        />

                        <button
                          onClick={handleSendMessage}
                          aria-label="button"
                          type="button"
                          className="avatar-sm p-0 rounded-circle mx-2 flex items-center justify-center bg-[rgba(152,14,255,255)]"
                          disabled={isBlocked}
                        >
                          <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.5835 8.08236C16.5835 8.63914 16.2243 9.13491 15.5996 9.44763L3.07573 15.7096C2.77064 15.8621 2.47318 15.9384 2.1986 15.9384C1.80123 15.9384 1.45114 15.7706 1.22918 15.4739C1.03927 15.2138 0.856214 14.7638 1.0774 14.0316L2.48844 9.32559C2.5342 9.1883 2.56471 9.02127 2.57996 8.84508H10.3063C10.7258 8.84508 11.0691 8.50185 11.0691 8.08236C11.0691 7.66286 10.7258 7.31963 10.3063 7.31963H2.57996C2.56395 7.14421 2.53344 6.97641 2.48844 6.83912L1.0774 2.13313C0.856214 1.40092 1.03927 0.95091 1.22995 0.691585C1.60368 0.188188 2.31301 0.0737803 3.07573 0.455141L15.6004 6.71708C16.2251 7.0298 16.5835 7.52557 16.5835 8.08236Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="blank-chat-view flex flex-col justify-center items-center h-[500px] text-gray-400 bg-white rounded-2xl p-6 border border-gray-100 shadow-sm text-center">
                    <IoChatbubblesSharp className="text-5xl text-purple-200 mb-3 animate-pulse" />
                    <h5 className="font-bold text-gray-700 text-lg mb-1">{t("Select a Conversation")}</h5>
                    <p className="text-xs text-gray-400 max-w-[280px]">{t("Choose a chat from the left sidebar to start messaging")}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {isVoiceCalling && (
        <WebCallManager
          channel={callChannelName}
          isVideo={false}
          isCaller={true}
          receiverId={receiverId}
          receiverName={userName || chatUserName}
          receiverPic={imageBaseURL + profilePic}
          onClose={() => setIsVoiceCalling(false)}
        />
      )}

      {isVideoCalling && (
        <WebCallManager
          channel={callChannelName}
          isVideo={true}
          isCaller={true}
          receiverId={receiverId}
          receiverName={userName || chatUserName}
          receiverPic={imageBaseURL + profilePic}
          onClose={() => setIsVideoCalling(false)}
        />
      )}

      {deviceCheck && (
        <div
          onClick={() => setDeviceCheck("")}
          id="BlockSection"
          className=" px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-[20%] bg-white max-_430_:w-[100%] max-_768_:w-[90%] max-_1030_:w-[50%] max-_1500_:w-[40%] rounded-[15px] p-4"
          >
            <h6 className="m-0">{deviceCheck}</h6>
          </div>
        </div>
      )}

      {warningData && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 99999 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content text-center p-4 shadow-lg" style={{ borderRadius: '16px', border: 'none' }}>
              <div className="text-warning mb-3">
                <svg width="56" height="56" fill="none" viewBox="0 0 24 24" stroke="#f59e0b" className="mx-auto">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <h4 className="font-weight-bold text-danger mb-2">Restricted Word Warning</h4>
              <p className="text-muted my-2" style={{ fontSize: '14px' }}>{warningData.error}</p>
              <div className="p-3 bg-light rounded my-3" style={{ fontSize: '14px', border: '1px solid #fee2e2' }}>
                <strong className="text-dark">Warnings Used: {warningData.warningCount} / {warningData.warningLimit}</strong><br/>
                <span className="text-danger font-weight-bold">Remaining Warnings: {warningData.remainingWarnings}</span>
              </div>
              <button className="btn btn-primary w-100 py-2" style={{ borderRadius: '8px', fontWeight: '600', backgroundColor: '#8c2bee', borderColor: '#8c2bee' }} onClick={() => setWarningData(null)}>
                I Understand
              </button>
            </div>
          </div>
        </div>
      )}

      {report && (
        <div
          onClick={() => ReportToggle("ReportSection")}
          id="ReportSection"
          className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-[420px] bg-white rounded-3xl p-6 shadow-2xl border border-gray-100 flex flex-col gap-4"
          >
            <div className="flex items-center justify-between border-b border-gray-100 pb-3">
              <h5 className="font-bold text-gray-900 text-base m-0">{t("Report User")}</h5>
              <button
                onClick={() => ReportToggle("ReportSection")}
                className="text-gray-400 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100 transition-colors border-0 bg-transparent"
              >
                <IoClose size={18} />
              </button>
            </div>
            <p className="text-xs text-gray-500 m-0">{t("Please select a reason for reporting this user:")}</p>
            <div className="flex flex-col gap-2 max-h-[260px] overflow-y-auto pr-1">
              {ReportComment?.map((item, index) => (
                <label
                  key={index}
                  className={`flex items-center gap-3 p-3 rounded-xl border transition-all cursor-pointer ${
                    dot === item ? "border-purple-600 bg-purple-50/60 font-bold" : "border-gray-100 hover:bg-gray-50"
                  }`}
                >
                  <input
                    type="radio"
                    name="reportReason"
                    value={item}
                    onChange={(e) => {
                      setDot(e.target.value);
                      setComment(e.target.value);
                    }}
                    checked={dot === item}
                    className="accent-purple-600 w-4 h-4"
                  />
                  <span className="text-xs text-gray-700">{item}</span>
                </label>
              ))}
            </div>
            <div className="flex items-center justify-end gap-2 pt-2 border-t border-gray-100">
              <button
                onClick={() => ReportToggle("ReportSection")}
                className="px-4 py-2 text-xs font-semibold text-gray-500 hover:bg-gray-100 rounded-xl transition-colors border-0 bg-transparent"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={SendReportHamdler}
                className="px-5 py-2 text-xs font-bold text-white bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700 rounded-xl shadow-md transition-all border-0"
              >
                {t("Submit Report")}
              </button>
            </div>
          </div>
        </div>
      )}

      {isVisible && (
        <div
          onClick={() => toggleBottomSheet("BlockSection")}
          id="BlockSection"
          className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-[380px] bg-white rounded-3xl p-6 shadow-2xl border border-gray-100 text-center flex flex-col items-center gap-3"
          >
            <div className="w-16 h-16 rounded-full bg-red-100 text-red-500 flex items-center justify-center text-2xl font-bold mb-1">
              🚫
            </div>
            <h5 className="font-bold text-gray-900 text-lg m-0">{t("Block User")}</h5>
            <p className="text-xs text-gray-500 m-0 px-2 leading-relaxed">
              {t("Are you sure you want to block this user? They will no longer be able to message or call you.")}
            </p>
            <div className="flex items-center justify-center gap-3 w-full mt-3">
              <button
                onClick={() => toggleBottomSheet("BlockSection")}
                className="w-1/2 py-2.5 text-xs font-semibold text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors bg-transparent"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={BlockHandler}
                className="w-1/2 py-2.5 text-xs font-bold text-white bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 rounded-xl shadow-md transition-all border-0"
              >
                {t("Yes, Block")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
);
};

export default UserChat;
